// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Notification from './notification';
import Notifications from '../state/notifications';
const isValidNotification = notification => (notification.title || notification.shortText || notification.url);

const NotificationsList = props =>
    <div className='notifications-list'>
        <h4 className='notifications-list-title'><FormattedMessage id='NOTIFICATIONS'/></h4>
        <ul>
            {props.notifications.filter(notification => isValidNotification(notification))
                .map((notification, index) =>
                    <Notification
                        key={index}
                        notification={notification}
                    />
                )}
        </ul>
    </div>;

NotificationsList.displayName = 'NotificationsList';
NotificationsList.propTypes = {
    notifications: PropTypes.instanceOf(Notifications).isRequired
};

export default NotificationsList;



// WEBPACK FOOTER //
// ./src/home-page/components/notifications.js